import { parseMessageContent } from './content-parser';
import { renderDocToText } from './render-doc-to-text';

export function renderContentToText(content: string): string {
  return renderDocToText(parseMessageContent(content));
}
